import type { Vat } from '~/types/user'

export interface FormData {
  name?: string
  email: string
  password: string
  phone?: string
  code?: string
}
export interface CountryData {
  name: string
  flag: string
  code: string
  dialCode: string
}
export interface ShippingAddress {
  id: number
  phone_number?: string
  phone_number_country_code?: string
  name: string
  shipping_address?: string
  postal_code?: string
  location?: string
  country?: string
  hide: boolean
  user: string
}

export interface MiioUser {
  account_type?: string
  country_of_origin?: string
  default_invoice_info?: Vat
  default_payment_method?: object
  default_shipping_address?: ShippingAddress
  email?: string
  has_set_country_of_origin?: boolean
  language?: string
  last_usage_date?: string
  name?: string
  payment_email?: string
  payment_logic?: string
  payment_name?: string
  payment_phone_number?: string
  phone_number?: string
  phone_number_country_code?: string
  photo_url?: string
  providers?: string[]
  store_default_address?: string
  user_on_boarding_store?: boolean
  default_rewards_wallet: string | null
}

export enum UserCookie {
  MiioUser = 1,
  AnonymousUser = 2
}
